"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlidingWindow = void 0;
const denque_1 = __importDefault(require("denque"));
class SlidingWindow {
    _capacity;
    _window = new denque_1.default();
    constructor(capacity) {
        this._capacity = capacity;
    }
    push(item) {
        this._window.push(item);
        if (this._window.length > this._capacity) {
            this._window.shift();
        }
    }
    shift() {
        return this._window.shift();
    }
    peekFront() {
        return this._window.peekFront();
    }
    toArray() {
        return this._window.toArray();
    }
    remove(index, count) {
        return this._window.remove(index, count);
    }
}
exports.SlidingWindow = SlidingWindow;
//# sourceMappingURL=SlidingWindow.js.map